/**
 * Включённые вопросы опроса по экологии (ecology-survey) — для мастера опроса клиента и команды.
 */
import { useEffect, useState } from 'react'
import { ecologyApi, type EcoQuestion } from '@/lib/api'
import { getErrorMessage } from '@/lib/errors'

export function useEcoQuestions(): {
  questions: EcoQuestion[] | null
  error: string | null
} {
  const [questions, setQuestions] = useState<EcoQuestion[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    ecologyApi
      .listQuestions(controller.signal)
      .then((qs) => {
        if (!controller.signal.aborted) setQuestions(qs)
      })
      .catch((err) => {
        if (!controller.signal.aborted)
          setError(getErrorMessage(err, 'Не удалось загрузить вопросы опроса'))
      })
    return () => controller.abort()
  }, [])

  return { questions, error }
}
